import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a screwdriver/wrench icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/screwdriver-wrench?f=classic&s=solid
 */
export const ScrewdriverWrenchIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faScrewdriverWrench} {...props} />;
};
